<template>
    <div class="mb-3">

        <div class="preview-container">
            <div class="preview-image-zone" v-if="imageUrl">
                <img :src="imageUrl" class="preview-image">
            </div>
            <div class="preview-label" v-else>
                {{ $t('feedbacks.click-picture button') }}
            </div>
        </div>

        <div class="mt-2 mb-5">
            <base-button type="white" size="sm" @click="openFile">
                <i class="fas fa-upload mr-1 mb-1"></i>
                {{ $t('feedbacks.select-picture') }}
            </base-button>

            <base-button type="white" size="sm" @click="openCamera" v-if="camera">
                <i class="fas fa-camera mr-1 mb-1"></i>
                {{ $t('feedbacks.take-picture') }}
            </base-button>

            <base-button type="white" size="sm" @click="openDrawing" v-if="drawing">
                <i class="fas fa-paint-brush mb-1"></i>
                {{ $t('feedbacks.draw-something') }}
            </base-button>
        </div>

        <portal to="modals">
            <camera v-if="camera"
                ref="cameraModal"
                @addedfile="fileTaken"
            />

            <drawing v-if="drawing"
                ref="drawingModal"
                @addedfile="fileTaken"
            />
            
            <file-input ref="filePickerInput"
                accept="image/jpeg,image/png"
                v-show="false"
                @change="fileSelected"
            ></file-input>

        </portal>

    </div>
</template>

<script>
    export default {

        props: {
            url: {
                type: String,
                required: true
            },

            formData: {
                type: Object,
                default: () => {}
            },

            drawing: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                imageUrl: null,
                file: null,
                lastFrom: null,
            }
        },

        computed: {

            camera() {
                return this.windowsOs
            },

            windowsOs() {
                return this.mobileOs == 'unknown'
            },

            mobileOs() {
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                // Windows Phone must come first because its UA also contains "Android"
                if (/windows phone/i.test(userAgent)) {
                    return 'windows'
                }

                if (/android/i.test(userAgent)) {
                    return 'android'
                }

                // iOS detection from: http://stackoverflow.com/a/9039885/177710
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return 'ios'
                }

                return 'unknown'
            },
        },

        methods: {

            open() {
                if (this.lastFrom == 'drawing') {
                    this.openDrawing()
                } else if (this.lastFrom == 'camera') {
                    this.openCamera()
                } else {
                    this.openFile()
                }
            },

            openDrawing() {
                this.reset()
                this.$refs.drawingModal.open()
            },

            openCamera() {               
                this.reset()
                this.$refs.cameraModal.open()
            },

            openFile() {
                this.reset()
                this.$refs.filePickerInput.trigger()
            },

            reset() {
                this.imageUrl = null;
                this.file = null
                this.$refs.filePickerInput.reset()
                if (this.drawing) {
                    this.$refs.drawingModal.reset()
                }
                if (this.camera) {
                    this.$refs.cameraModal.reset()
                }
            },

            fileSelected(files) {
                this.file = files[0]
                if (this.file) {
                    this.imageUrl = URL.createObjectURL(this.file);
                    this.lastFrom = 'file'
                    this.$emit('addedfile', { sender: this })
                }
            },

            fileTaken(event) {
                this.file = event.file
                this.imageUrl = event.url
                this.lastFrom = event.from
                this.$emit('addedfile', { sender: this })
            },

            send() {

                let formData = new FormData();
                formData.append("_token", this.$auth['csrf-token']);
                for (let prop in this.formData) {
                    // Workaround to not send null values as strings!
                    if (this.formData[prop] !== null) {
                        formData.append(prop, this.formData[prop]);
                    }
                }
                if (this.file) {
                    formData.append('file', this.file);
                }

                axios.post(this.url, formData)
                    .then(resp => {
                        this.$emit('complete', null)
                        this.$emit('success', null)
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            this.$emit('complete', null)
                            this.$emit('errors', error.response.data.errors)
                        } else {
                            //this.$auth.handleErrorVm(error, this)
                        }
                    })
            },
        },
    }
</script>

<style scoped>

    .preview-container {
        background-color: white;
        border: 1px dashed #dee2e6;
        border-radius: .375rem;
        height: 200px;
        color: #8898aa;
    }
    .preview-image-zone {
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden        
    }
    .preview-image {
        flex-shrink: 1;
        object-fit: cover;
        min-width: 100%;
        min-height: 100%
    }
    .preview-label {
        width: 100%;
        padding: 5.5rem 1rem;
        text-align: center;
    }

</style>
